/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Horizontal_Padding_AriaInputs */



/**
* | output |
* | --- |
* | "Horizontal Padding" |
*
* @param {Video_Export_Horizontal_Padding_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_horizontal_padding_aria = /** @type {((inputs?: Video_Export_Horizontal_Padding_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Horizontal_Padding_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marge horizontale")
	if (locale === "de") return /** @type {LocalizedString} */ ("Horizontale Polsterung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Imbottitura orizzontale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Горизонтальная отступ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Relleno horizontal")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("水平边距")
	if (locale === "ja") return /** @type {LocalizedString} */ ("水平パディング")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्षैतिज पैडिंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Acolchoamento horizontal")
	return /** @type {LocalizedString} */ ("Horizontal Padding")
});